import React from 'react'

import { Button, ButtonProps } from '../../../components/button/button.js'
import { GridColumn } from '../../../components/grid/grid-column.js'
import { Grid } from '../../../components/grid/grid.js'
import { useCurrentBreakPoint } from '../../../components/helper/hooks/use-current-breakpoint.js'
import { PageTitle, PageTitleProps } from '../../../components/page-title/page-title.js'
import { SubscriptionCard, SubscriptionCardProps } from '../../../components/subscription-card/subscription-card.js'
import { ViewBase, ViewBaseProps } from '../../base/base.js'

export interface MySubscriptionsProps {
    title: PageTitleProps
    items: SubscriptionCardProps[] | ViewSubscriptionsBlockProps[]
    addNewButton?: ButtonProps
    previousButton?: ButtonProps
}

export interface ViewSubscriptionsBlockProps {
    title: string
    items: SubscriptionCardProps[]
}

export interface ViewSubscriptionsProps extends ViewBaseProps, MySubscriptionsProps {}

export const MySubscriptions = (props: MySubscriptionsProps): JSX.Element => {
    const bp = useCurrentBreakPoint()
    const isMobile = bp ? ['xs', 'sm'].includes(bp) : true

    const isBlock = (
        block: SubscriptionCardProps | ViewSubscriptionsBlockProps,
    ): block is ViewSubscriptionsBlockProps => (block as ViewSubscriptionsBlockProps).items !== undefined

    const renderButtons = () => (
        <GridColumn width={['min-md']}>
            <Grid reverse={['md']}>
                {props.addNewButton && (
                    <GridColumn width={['md']}>
                        <Button isBlock={isMobile} {...props.addNewButton} />
                    </GridColumn>
                )}
                {props.previousButton && (
                    <GridColumn width={['md']}>
                        <Button isBlock={isMobile} {...props.previousButton} variant="secondary" />
                    </GridColumn>
                )}
            </Grid>
        </GridColumn>
    )

    const renderBlock = (block: ViewSubscriptionsBlockProps, key: number) => (
        <GridColumn className="text__margin-double" key={key}>
            <div className="text">
                <h2 className="text-large">{block.title}</h2>
                <Grid>
                    {block.items.map((item: SubscriptionCardProps, index: number) => (
                        <GridColumn width={['md-6', 'xl-4']} key={index}>
                            <SubscriptionCard {...item} />
                        </GridColumn>
                    ))}
                </Grid>
            </div>
        </GridColumn>
    )

    return (
        <div className="text">
            <Grid align={['middle-xs']} noWrap={true}>
                <GridColumn width={['max-md']}>
                    <PageTitle {...props.title} />
                </GridColumn>
                {!isMobile && (props.addNewButton || props.previousButton) && renderButtons()}
            </Grid>
            <Grid className="text__margin-double">
                {props.items.map((item: SubscriptionCardProps | ViewSubscriptionsBlockProps, index: number) => {
                    if (isBlock(item)) {
                        return renderBlock(item, index)
                    } else {
                        return (
                            <GridColumn width={['md-6', 'xl-4']} key={index}>
                                <SubscriptionCard {...item} />
                            </GridColumn>
                        )
                    }
                })}
            </Grid>
            {isMobile && <Grid>{renderButtons()}</Grid>}
        </div>
    )
}

export const ViewSubscriptions = (props: ViewSubscriptionsProps): JSX.Element => {
    return (
        <ViewBase {...props}>
            <MySubscriptions {...props} />
        </ViewBase>
    )
}
